import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

type OmniSubAccountStatusResponse = {
	provisioningStatus: 'ACTIVE' | 'FAILED' | 'CLOSED' | 'PROVISIONING' | 'NOT_PROVISIONED';
};

export const omniSubAccountStatus: RouteResource<OmniSubAccountStatusResponse> =
	createResource<OmniSubAccountStatusResponse>({
		type: 'OMNI_SUB_ACCOUNT_STATUS',
		getKey: () => 'OMNI_SUB_ACCOUNT_STATUS',
		getData: async () =>
			performGetRequest<OmniSubAccountStatusResponse>(
				'/gateway/api/jsm/csm/api/v1/omni/twilio/subaccount/status',
			),
		maxAge: 0,
		isBrowserOnly: true,
	});
